import { StorageKeys } from '@ui/legacy-lib';

type HomepageStorageKeys = StorageKeys;

export const storageKeys: HomepageStorageKeys = {
  tokenKey: 'token',
  localeKey: 'locale'
};
